export const BlocklyCustomRU = {
    UNDO: "\u21B6 Отменить",
    REDO: "\u21B7 Повторить",
    CLEAN_UP: "\u2833 Упорядочить",
    DELETE_BLOCK: "\u2298 Удалить",
    DELETE_X_BLOCKS: "\u2298 Удалить %1 блок(ов)",
    LOAD: "\u{1F845} Загрузить программу...",
    SAVE: "\u{1F847} Сохранить программу...",
    CODE_EXPORT: "\u2756 Экспортировать код...",
    INLINE_INPUTS: "\u25EB Расположить горизонтально",
    EXTERNAL_INPUTS: "\u229F Расположить вертикально",
    DUPLICATE_BLOCK: "\uA698 Клонировать",
    ADD_COMMENT: "\u270E Комментарий",
    
    REMOVE_COMMENT: "\u{1F7A9} Удалить комментарий",
    COLLAPSE_BLOCK: "\u25F2 Свернуть",
    EXPAND_BLOCK: "\u29C9 Развернуть",
    DISABLE_BLOCK: "\u{1F5F2} Отключить",
    ENABLE_BLOCK: "\u{1F5F2} Включить",

    EXEC_ERROR: "Ошибка программы",
    EXEC_SUCCESS: "Программа завершена",
    EMPTY_PROGRAM: "Пустая программа",
    SEE_CONSOLE: "Подробности смотрите в консоли браузера.",

    ROCKSI_CATEGORY_MOVE: "Движение",
    ROCKSI_CATEGORY_OBJECTS: "Объекты",
    ROCKSI_CATEGORY_LOGIC: "Логика",
    ROCKSI_CATEGORY_EXTRAS: "Дополнительно",
    ROCKSI_CATEGORY_EXAMPLES: "Примеры",

    ROCKSI_BLOCK_MOVE: "Переместить %1",
    ROCKSI_BLOCK_MOVE_TOOLTIP: "Подключите положение в пространстве суставов или в рабочем пространстве, чтобы робот переместился в него",
    ROCKSI_BLOCK_DEFAULTPOSE: "Исходное положение",
    ROCKSI_BLOCK_DEFAULTPOSE_TOOLTIP: "Исходное положение робота",
    ROCKSI_BLOCK_JOINTSPACEPOSE_TOOLTIP: "Положение в пространстве суставов: один угол на каждый сустав, начиная от основания",
    ROCKSI_BLOCK_TASKSPACEPOSE_TOOLTIP: "Положение в рабочем пространстве: позиция и ориентация в пространстве",
    ROCKSI_BLOCK_JOINTABSOLUTE: "Угол сустава (абсолютный) %1 %2",
    ROCKSI_BLOCK_JOINTABSOLUTE_TOOLTIP: "Переместить один сустав в заданный угол",
    ROCKSI_BLOCK_JOINTRELATIVE: "Угол сустава (относительный) %1 %2",
    ROCKSI_BLOCK_JOINTRELATIVE_TOOLTIP: "Повернуть один сустав на заданную величину",

    ROCKSI_BLOCK_GRIPPEROPEN: "Открыть захват",
    ROCKSI_BLOCK_GRIPPEROPEN_TOOLTIP: "Открывает захват на полную ширину",
    ROCKSI_BLOCK_GRIPPERCLOSE: "Закрыть захват",
    ROCKSI_BLOCK_GRIPPERCLOSE_TOOLTIP: "Полностью закрывает захват",
    ROCKSI_BLOCK_SIMOBJECT: "Разместить %1", 
    ROCKSI_BLOCK_SIMOBJECT_CUBE: "Куб",
    ROCKSI_BLOCK_SIMOBJECT_SPHERE: "Шар",
    ROCKSI_BLOCK_SIMOBJECT_ROCK: "Камень",
    ROCKSI_BLOCK_SIMOBJECT_SHAFT: "Вал",
    ROCKSI_BLOCK_SIMOBJECT_CUSTOM: "Свой объект...",
    ROCKSI_BLOCK_SIMOBJECT_COLOR: "цветом %1",
    ROCKSI_BLOCK_SIMOBJECT_POSITION: "в позиции %1",
    ROCKSI_BLOCK_SIMOBJECT_SCALE: "масштабом %1",
    ROCKSI_BLOCK_SIMOBJECT_TOOLTIP: "Добавляет объект в сцену, который робот может захватывать",
    ROCKSI_BLOCK_PHYSICSDONE: "Физическая симуляция завершена?",
    ROCKSI_BLOCK_PHYSICSDONE_TOOLTIP: "Возвращает true, когда все объекты перестали двигаться (не считая робота)",
    ROCKSI_BLOCK_HOLDING: "Удерживает объект?",
    ROCKSI_BLOCK_HOLDING_TOOLTIP: "Возвращает true, если робот держит объект",

    ROCKSI_BLOCK_COMMENT: "Комментарий %1",
    ROCKSI_BLOCK_COMMENT_TOOLTIP: "Комментарий, игнорируется при выполнении",
    ROCKSI_BLOCK_WAIT: "Ждать %1 с",
    ROCKSI_BLOCK_WAIT_TOOLTIP: "Ждёт перед выполнением следующего блока",
    ROCKSI_BLOCK_SETSPEED: "Установить скорость %1: %2 %%",
    ROCKSI_BLOCK_SETSPEED_MOVE: "движения",
    ROCKSI_BLOCK_SETSPEED_GRIPPER: "захвата",
    ROCKSI_BLOCK_SETSPEED_TOOLTIP: "Изменяет скорость, с которой движется робот",
    ROCKSI_BLOCK_JOINTLOCK: "Заблокировать %1",
    ROCKSI_BLOCK_JOINTLOCK_TOOLTIP: "Запрещает суставу двигаться во время выполнения программы",
    ROCKSI_BLOCK_JOINTUNLOCK: "Разблокировать %1",
    ROCKSI_BLOCK_JOINTUNLOCK_TOOLTIP: "Позволяет суставу снова двигаться во время выполнения программы",

    ROCKSI_BLOCK_SCALE: "%1",
    ROCKSI_BLOCK_SCALE_TOOLTIP: "Коэффициент",

    ROCKSI_EXAMPLE_PICK_N_PLACE: "Взять и положить: поднять объект и отпустить его",
    ROCKSI_EXAMPLE_PICK_N_PLACE_COMMENT_1: "Положения в пространстве суставов всегда надёжнее!"
}